import cn from 'classnames';
import { useCallback, useMemo } from 'react';

import { AccountRoutes } from '@webapp/account/src/resources/routes';

import { DoubleCross, DoubleMark, RequiredMark } from '@webapp/common/assets/icons';
import { Button } from '@webapp/common/components/button';
import { CssPageBlock } from '@webapp/common/components/survey-custom';
import { history } from '@webapp/common/lib/history';
import { formatAmount } from '@webapp/common/lib/ui';
import { TestCheckStatus } from '@webapp/common/resources/survey';

import css from './misc.css';

export const NoData: FC<{
    className?: string;
}> = ({ className = '' }) => <div className={className}>Нет данных</div>;

export const NoAccess: FC = () => <div className='content'>Доступ к разделу закрыт</div>;

export const TotalAnswers: FC<{
    totalCount: number;
}> = ({ totalCount }) => <div className={css.answer}>{`Всего ответов: ${formatAmount(totalCount)}`}</div>;

export const TotalCantRate: FC<{
    totalCantRate: number;
}> = ({ totalCantRate }) => <h4>{`Не могу оценить: ${formatAmount(totalCantRate)}`}</h4>;

export const SelfCount: FC<{
    count: number;
}> = ({ count }) => <h3>Свободные ответы ({count})</h3>;

export const ProPlusMark: FC<{ label?: string }> = ({ label = '(PRO+)' }) => {
    const onClick = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        history.push(AccountRoutes.ordersLicence.link);
    }, []);
    return (
        <span className={css.proPlus} onClick={onClick}>
            &nbsp;{label}
        </span>
    );
};

export const QuestionOrder: FC<{
    order: number;
    invalid?: boolean;
    style?: CSSProperties;
    className?: string;
}> = ({ invalid, order, style, className }) => (
    <div className={cn(CssPageBlock.QUESTION_ORDER, cn(css.order, className, invalid && css.invalid))} style={style}>
        {order}.
    </div>
);

export const AnswerIcon: FC<{
    checked: boolean;
    testCheckStatus: TestCheckStatus;
}> = ({ checked, testCheckStatus }) => (
    <div className={css.answerIcon}>
        {testCheckStatus === TestCheckStatus.VALID ? (
            <DoubleMark className={css.valid} />
        ) : checked ? (
            <DoubleCross className={css.invalid} />
        ) : (
            <div />
        )}
    </div>
);

export const RestartButton: FC = () => {
    const onClick = useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <Button bordered slim onClick={onClick}>
            Новый ответ
        </Button>
    );
};

export const Required: FC<{
    className?: string;
    color?: string;
}> = ({ className, color }) => {
    const style = useMemo(() => ({ color }), [color]);
    return (
        <span className={cn(css.required, className)} style={style}>
            <RequiredMark />
        </span>
    );
};
